// import React, { useState, useEffect } from 'react';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';
// import Grid from '@mui/material/Grid';
// import axios from 'axios';
// import Loader from '../common/Loader';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import toast from 'react-hot-toast';

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '90%',
//   maxWidth: 600,
//   height: 'auto',
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: 24,
//   borderRadius: '16px',
//   p: { xs: 2, md: 2 },
// };

// const EditBlogModal = ({ open, handleClose, blogDetailsData, getBlogById }) => {
//   const [formData, setFormData] = useState({
//     title: '',
//     author: '',
//     dateOfPublish: '',
//     description: '',
//     image: '',
//   });
//   const [imageFile, setImageFile] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (blogDetailsData) {
//       setFormData({
//         title: blogDetailsData.title,
//         author: blogDetailsData.author,
//         dateOfPublish: blogDetailsData.dateOfPublish,
//         description: Array.isArray(blogDetailsData.description)
//           ? blogDetailsData.description.join('')
//           : blogDetailsData.description,
//         image: blogDetailsData.image[0] || '',
//       });
//       // Show existing image as preview
//       setImagePreview(blogDetailsData.image[0] || null);
//       setImageFile(null);
//     }
//   }, [blogDetailsData]);

//   const handleQuillChange = (value) => {
//     setFormData((prev) => ({ ...prev, description: value }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageFile(file);
//       setImagePreview(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     let imageUrl = formData.image;
//     if (imageFile) {
//       const uploadData = new FormData();
//       uploadData.append('file', imageFile);
//       uploadData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

//       try {
//         const response = await axios.post(
//           `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//           uploadData
//         );
//         imageUrl = response.data.secure_url;
//       } catch (error) {
//         console.error('Error uploading image:', error);
//       }
//     }

//     const payload = {
//       title: formData.title,
//       author: formData.author,
//       dateOfPublish: formData.dateOfPublish || new Date().toISOString(),
//       image: [imageUrl],
//       description: formData.description,
//     };

//     try {
//       await axios.put(
//         `${process.env.REACT_APP_API_URL}/blog-post/edit-blog/${blogDetailsData._id}`,
//         payload,
//         { headers: { 'Content-Type': 'application/json' } }
//       );

//       getBlogById();
//       handleClose();
//       toast.success ('Blog Updated Successfull')
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to update blog.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={style}>
//         {/* Centered Loading Overlay */}
//         {isLoading && (
//           <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-80 rounded-2xl">
//             <Loader />
//             <p className="mt-3 text-sm font-medium text-gray-500 tracking-wide">Uploading & Saving...</p>
//           </div>
//         )}

//         <Typography variant="h6" className="text-center mb-4 relative">
//           Edit Blog
//           <div
//             onClick={handleClose}
//             className="text-xl absolute top-0 right-2 cursor-pointer text-[#FF8607]"
//           >
//             ✕
//           </div>
//         </Typography>

//         <form className="h-[22rem] overflow-y-scroll" onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <input
//                 type="text"
//                 name="title"
//                 placeholder="Title"
//                 value={formData.title}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <input
//                 type="text"
//                 name="author"
//                 placeholder="Author"
//                 value={formData.author}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <input
//                 type="date"
//                 name="dateOfPublish"
//                 value={formData.dateOfPublish?.slice(0, 10)}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography variant="subtitle1" className="mb-1">Description</Typography>
//               <ReactQuill
//                 theme="snow"
//                 value={formData.description}
//                 onChange={handleQuillChange}
//                 modules={{
//                   toolbar: [
//                     [{ header: [1, 2, 3, false] }],
//                     ['bold', 'italic', 'underline', 'strike'],
//                     [{ color: [] }, { background: [] }],
//                     [{ align: [] }],
//                     ['blockquote', 'code-block'],
//                     ['link', 'image'],
//                     ['clean'],
//                   ],
//                 }}
//                 formats={[
//                   'header', 'bold', 'italic', 'underline', 'strike',
//                   'color', 'background', 'align', 'blockquote',
//                   'code-block', 'link', 'image',
//                 ]}
//                 className="bg-white"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <div className="mb-1 text-sm font-medium text-gray-700">
//                 Choose a Blog Image (500×400 size)
//               </div>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 className="mt-1"
//               />
//               {/* Image Preview — shows existing or newly selected */}
//               {imagePreview && (
//                 <div className="mt-3">
//                   <p className="text-xs text-gray-500 mb-1">
//                     {imageFile ? 'New Preview:' : 'Current Image:'}
//                   </p>
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="w-full max-h-48 object-cover rounded-lg border border-gray-200 shadow-sm"
//                   />
//                 </div>
//               )}
//             </Grid>

//             <Grid item xs={12}>
//               <button
//                 type="submit"
//                 className="w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-md"
//                 disabled={isLoading}
//               >
//                 Update Blog
//               </button>
//             </Grid>
//           </Grid>
//         </form>
//       </Box>
//     </Modal>
//   );
// };

// export default EditBlogModal;

import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import Loader from '../common/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  height: 'auto',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: '16px',
  p: { xs: 2, md: 2 },
};

const EditBlogModal = ({ open, handleClose, blogDetailsData, getBlogById }) => {
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    dateOfPublish: '',
    description: '',
    image: '',
    metaTitle: '',
    metaDescription: '',
    keywords: '',
    canonical: '',
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (blogDetailsData) {
      setFormData({
        title: blogDetailsData.title,
        author: blogDetailsData.author,
        dateOfPublish: blogDetailsData.dateOfPublish,
        description: Array.isArray(blogDetailsData.description)
          ? blogDetailsData.description.join('')
          : blogDetailsData.description,
        image: blogDetailsData.image[0] || '',
        metaTitle: blogDetailsData.metaTitle || '',
        metaDescription: blogDetailsData.metaDescription || '',
        keywords: blogDetailsData.keywords || '',
        canonical: blogDetailsData.canonical || '',
      });
      setImagePreview(blogDetailsData.image[0] || null);
      setImageFile(null);
    }
  }, [blogDetailsData]);

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let imageUrl = formData.image;
    if (imageFile) {
      const uploadData = new FormData();
      uploadData.append('file', imageFile);
      uploadData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

      try {
        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
          uploadData
        );
        imageUrl = response.data.secure_url;
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }

    const payload = {
      title: formData.title,
      author: formData.author,
      dateOfPublish: formData.dateOfPublish || new Date().toISOString(),
      image: [imageUrl],
      description: formData.description,
      metaTitle: formData.metaTitle || `${formData.title} | BBSR Services`,
      metaDescription: formData.metaDescription,
      keywords: formData.keywords,
      canonical: formData.canonical,
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/blog-post/edit-blog/${blogDetailsData._id}`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      getBlogById();
      handleClose();
      toast.success('Blog Updated Successfully');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update blog.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {isLoading && (
          <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-80 rounded-2xl">
            <Loader />
            <p className="mt-3 text-sm font-medium text-gray-500 tracking-wide">Uploading & Saving...</p>
          </div>
        )}

        <Typography variant="h6" className="text-center mb-4 relative">
          Edit Blog
          <div
            onClick={handleClose}
            className="text-xl absolute top-0 right-2 cursor-pointer text-[#FF8607]"
          >
            ✕
          </div>
        </Typography>

        <form className="h-[32rem] overflow-y-scroll px-2" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <label className="text-sm font-medium">Blog Title</label>
              <input
                type="text"
                name="title"
                placeholder="Enter blog title"
                value={formData.title}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Author</label>
              <input
                type="text"
                name="author"
                placeholder="Author name"
                value={formData.author}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Publish Date</label>
              <input
                type="date"
                name="dateOfPublish"
                value={formData.dateOfPublish?.slice(0, 10)}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1"
              />
            </Grid>

            {/* SEO Fields */}
            <Grid item xs={12}>
              <div className="border-t border-gray-200 my-2 pt-2">
                <Typography variant="subtitle1" className="font-semibold text-blue-600">
                  SEO Settings
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Meta Title</label>
              <input
                type="text"
                name="metaTitle"
                placeholder="Meta title for SEO"
                value={formData.metaTitle}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Recommended: 50-60 characters</p>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Meta Description</label>
              <textarea
                name="metaDescription"
                placeholder="Brief description for search results"
                value={formData.metaDescription}
                onChange={handleChange}
                rows="2"
                className="w-full border p-2 rounded mt-1 text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Recommended: 150-160 characters</p>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Keywords</label>
              <input
                type="text"
                name="keywords"
                placeholder="comma separated keywords"
                value={formData.keywords}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Canonical URL</label>
              <input
                type="url"
                name="canonical"
                placeholder="https://www.bbsrservices.co.in/blog/your-blog"
                value={formData.canonical}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Description</label>
              <ReactQuill
                theme="snow"
                value={formData.description}
                onChange={handleQuillChange}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    ['blockquote', 'code-block'],
                    ['link', 'image'],
                    ['clean'],
                  ],
                }}
                formats={[
                  'header', 'bold', 'italic', 'underline', 'strike',
                  'color', 'background', 'align', 'blockquote',
                  'code-block', 'link', 'image',
                ]}
                className="bg-white mt-1"
              />
            </Grid>

            <Grid item xs={12}>
              <div className="mb-1 text-sm font-medium text-gray-700">
                Choose a Blog Image (500×400 size)
              </div>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="mt-1"
              />
              {imagePreview && (
                <div className="mt-3">
                  <p className="text-xs text-gray-500 mb-1">
                    {imageFile ? 'New Preview:' : 'Current Image:'}
                  </p>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-full max-h-48 object-cover rounded-lg border border-gray-200 shadow-sm"
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12}>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-md"
                disabled={isLoading}
              >
                Update Blog
              </button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default EditBlogModal;